/* This is generated code, don't alter */
var IfcStructuralSurfaceMemberTypeEnum;
(function (IfcStructuralSurfaceMemberTypeEnum) {
    IfcStructuralSurfaceMemberTypeEnum[IfcStructuralSurfaceMemberTypeEnum["BENDING_ELEMENT"] = 0] = "BENDING_ELEMENT";
    IfcStructuralSurfaceMemberTypeEnum[IfcStructuralSurfaceMemberTypeEnum["MEMBRANE_ELEMENT"] = 1] = "MEMBRANE_ELEMENT";
    IfcStructuralSurfaceMemberTypeEnum[IfcStructuralSurfaceMemberTypeEnum["SHELL"] = 2] = "SHELL";
    IfcStructuralSurfaceMemberTypeEnum[IfcStructuralSurfaceMemberTypeEnum["USERDEFINED"] = 3] = "USERDEFINED";
    IfcStructuralSurfaceMemberTypeEnum[IfcStructuralSurfaceMemberTypeEnum["NOTDEFINED"] = 4] = "NOTDEFINED";
})(IfcStructuralSurfaceMemberTypeEnum || (IfcStructuralSurfaceMemberTypeEnum = {}));
const IfcStructuralSurfaceMemberTypeEnumCount = 5;
export { IfcStructuralSurfaceMemberTypeEnum, IfcStructuralSurfaceMemberTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcStructuralSurfaceMemberTypeEnum = new Int32Array([27]);
let prefixSumAddressIfcStructuralSurfaceMemberTypeEnum = new Uint32Array([0, 12, 30, 37, 54, 67]);
let slotMapIfcStructuralSurfaceMemberTypeEnum = new Int32Array([4, 1, 2, 0, 3]);
let encodedDataIfcStructuralSurfaceMemberTypeEnum = (new TextEncoder()).encode(".NOTDEFINED..MEMBRANE_ELEMENT..SHELL..BENDING_ELEMENT..USERDEFINED.");
let IfcStructuralSurfaceMemberTypeEnumSearch = new MinimalPerfectHash(gMapIfcStructuralSurfaceMemberTypeEnum, prefixSumAddressIfcStructuralSurfaceMemberTypeEnum, slotMapIfcStructuralSurfaceMemberTypeEnum, encodedDataIfcStructuralSurfaceMemberTypeEnum);
export { IfcStructuralSurfaceMemberTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcStructuralSurfaceMemberTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcStructuralSurfaceMemberTypeEnumSearch, input, cursor, endCursor);
}
